<template>
  <div class="form-group mb-4">
    <label v-if="label" :for="id" class="form-label">{{ label }}</label>
    <input
      class="form-control"
      :id="id"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      v-bind="$attrs"
      @input="
        $emit('update:modelValue', $event.target.value);
        $emit('input');
      "
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      v-phone-mask
    />
    <small v-if="error" class="form-text text-error">{{ error }}</small>
    <small v-else-if="hint" class="form-text text-muted">{{ hint }}</small>
  </div>
</template>

<script>
import AppInput from "./AppInput.vue";
import phoneMask from "@/directives/PhoneMask";

export default {
  name: "AppPhoneInput",
  extends: AppInput,
  directives: {
    phoneMask,
  },
  emits: ["update:modelValue", "input", "blur", "focus"],
};
</script>

<style scoped lang="less">
@import "@/styles/_input-styles.less";
</style>
